<template>
  <el-dialog
    title="商品详情"
    :visible.sync="dialogVisible"
    width="900px"
    :before-close="handleClose">
    <div v-if="productDetail">
      <div class="product-detail">
        <div class="product-preview">
          <div class="product-images">
            <div v-if="productDetail.coverImage" class="image-gallery">
              <el-image
                v-for="(img, index) in parseImages(productDetail.coverImage)"
                :key="index"
                :src="img"
                :preview-src-list="parseImages(productDetail.coverImage)"
                :initial-index="index"
                style="width: 100px; height: 100px; border-radius: 8px; margin-right: 10px; margin-bottom: 10px;"
                fit="cover"
              />
            </div>
          </div>
          <div class="product-info">
            <h3>{{ productDetail.title }}</h3>
            <p class="description">{{ productDetail.description }}</p>
            <div class="price-info">
              <span class="current-price">¥{{ productDetail.price }}</span>
              <span v-if="productDetail.originalPrice" class="original-price">¥{{ productDetail.originalPrice }}</span>
            </div>
            <div class="meta-info">
              <el-tag>{{ getCategoryText(productDetail.categoryId) }}</el-tag>
              <span class="meta-item">用户: {{ productDetail.nickname }}</span>
              <span class="meta-item">浏览: {{ productDetail.viewCount || 0 }}</span>
            </div>
          </div>
        </div>

        <el-form label-width="100px" class="detail-form">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="商品状态:">
                <el-tag :type="getStatusTagType(productDetail.status)">
                  {{ getStatusText(productDetail.status) }}
                </el-tag>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="审核状态:">
                <el-tag :type="getReviewStatusTagType(productDetail.reviewStatus)">
                  {{ getReviewStatusText(productDetail.reviewStatus) }}
                </el-tag>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="售价:">{{ (productDetail.price !== null && productDetail.price !== undefined && productDetail.price !== '' && Number(productDetail.price) === 0) ? '价格线聊' : '¥' + (productDetail.price == null ? '' : productDetail.price) }}</el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="原价:">
                <span v-if="productDetail.originalPrice">¥{{ productDetail.originalPrice }}</span>
                <span v-else>--</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="用户名称:">{{ productDetail.nickname }}</el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="创建时间:">{{ productDetail.createTime }}</el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="地区:">{{ productDetail.province }} {{ productDetail.city }} {{ productDetail.district || '' }}</el-form-item>
            </el-col>
<!--            <el-col :span="12">-->
<!--              <el-form-item label="新旧程度:">{{ getConditionText(productDetail.condition) }}</el-form-item>-->
<!--            </el-col>-->
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="发货方式:">{{ getShippingMethodText(productDetail.shippingMethod) }}</el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="浏览量:">{{ productDetail.viewCount || 0 }}</el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { axios } from "../../config/axios";

export default {
  name: "product-detail-dialog",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    productId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      productDetail: null
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      }
    }
  },
  watch: {
    visible(newVal) {
      if (newVal && this.productId) {
        this.getProductDetail(this.productId);
      }
    }
  },
  methods: {
    // 获取商品详情
    getProductDetail(id) {
      axios.get(`/admin/product/${id}`).then(result => {
        if (result.code === 200) {
          this.productDetail = result.data;
        } else {
          this.$message.error('获取商品详情失败');
          this.dialogVisible = false;
        }
      }).catch(err => {
        console.error(err);
        this.$message.error('网络异常，请重试');
        this.dialogVisible = false;
      });
    },

    // 关闭弹窗
    handleClose() {
      this.productDetail = null;
      this.dialogVisible = false;
    },

    // 解析图片URL（分号分隔）
    parseImages(coverImage) {
      if (!coverImage) return [];
      return coverImage.split(';').filter(img => img.trim());
    },

    // 获取分类文本
    getCategoryText(categoryId) {
      const categoryMap = {
        1: '引擎配件',
        2: '车身配件',
        3: '底盘配件',
        4: '电气配件',
        5: '其他'
      };
      return categoryMap[categoryId] || '未知';
    },

    // 获取状态文本
    getStatusText(status) {
      const statusMap = {
        0: '未审核',
        1: '草稿',
        2: '已上架',
        3: '已下架',
        4: '已售出'
      };
      return statusMap[status] || '未知';
    },

    // 获取状态标签类型
    getStatusTagType(status) {
      const typeMap = {
        0: 'warning',  // 未审核
        1: 'info',     // 草稿
        2: 'success',  // 已上架
        3: 'danger',   // 已下架
        4: 'primary'   // 已售出
      };
      return typeMap[status] || 'info';
    },

    // 获取审核状态文本
    getReviewStatusText(status) {
      const statusMap = {
        0: '未审核',
        1: '审核通过',
        2: '未通过',
        3: '审批退回',
        4: '已完结'
      };
      return statusMap[status] || '未审核';
    },

    // 获取审核状态标签类型
    getReviewStatusTagType(status) {
      const typeMap = {
        0: 'info',     // 未审核
        1: 'success',  // 审核通过
        2: 'warning',  // 未通过
        3: 'warning',  // 审批退回
        4: 'info'      // 已完结
      };
      return typeMap[status] || 'info';
    },

    // 获取新旧程度文本
    getConditionText(condition) {
      const conditionMap = {
        1: '全新',
        2: '99新',
        3: '95新',
        4: '9成新',
        5: '其他'
      };
      return conditionMap[condition] || '未知';
    },

    // 获取发货方式文本
    getShippingMethodText(method) {
      const methodMap = {
        1: '邮寄',
        2: '面交',
        3: '都可以'
      };
      return methodMap[method] || '未知';
    }
  }
}
</script>

<style lang="less" scoped>
.product-detail {
  .product-preview {
    display: flex;
    margin-bottom: 20px;

    .product-images {
      margin-right: 20px;

      .image-gallery {
        margin-top: 10px;
        display: flex;
        flex-wrap: wrap;
      }
    }

    .product-info {
      flex: 1;

      h3 {
        margin: 0 0 10px 0;
        color: #333;
        font-size: 18px;
      }

      .description {
        color: #666;
        line-height: 1.5;
        margin-bottom: 15px;
      }

      .price-info {
        margin-bottom: 15px;

        .current-price {
          color: #E6A23C;
          font-size: 24px;
          font-weight: bold;
          margin-right: 10px;
        }

        .original-price {
          color: #999;
          font-size: 16px;
          text-decoration: line-through;
        }
      }

      .meta-info {
        display: flex;
        align-items: center;
        gap: 15px;

        .meta-item {
          color: #999;
          font-size: 14px;
        }
      }
    }
  }

  .detail-form {
    .el-form-item {
      margin-bottom: 12px;
    }
  }
}

@media screen and (max-width: 768px) {
  .product-detail {
    .product-preview {
      flex-direction: column;

      .product-images {
        margin-right: 0;
        margin-bottom: 15px;
      }
    }
  }
}
</style>
